import { useRef } from 'react';
import { format, isSameDay } from 'date-fns';

const THEME = {
  activePill: 'rgba(65, 100, 81, 1)',
  inactivePill: 'rgba(236, 236, 236, 1)',
  activeText: 'rgba(255, 255, 255, 1)',
  inactiveText: 'rgba(50, 50, 50, 1)',
  font: 'var(--font-display)',
};

interface DateStripProps {
  currentDate: Date;
  onDateChange: (date: Date) => void;
  availableDates: Array<{ date: Date; dateStr: string; vendorCount: number }>;
  shareViewState?: {
    active: boolean;
    eventId: number;
    date: Date;
    coordinates: [number, number];
    isPast: boolean;
    isFuture: boolean;
  } | null;
}

export default function DateStrip({
  currentDate,
  onDateChange,
  availableDates,
  shareViewState,
}: DateStripProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const getLabel = (date: Date) => {
    const today = new Date();
    if (isSameDay(date, today)) return 'today';
    return format(date, 'EEE d');
  };

  return (
    <div
      ref={scrollRef}
      style={{
        display: 'flex',
        gap: '8px',
        overflowX: 'auto',
        padding: '8px 16px 8px',
        scrollbarWidth: 'none',
      }}
    >
      {availableDates.map(({ date, dateStr }) => {
        const isActive = isSameDay(date, currentDate);
        return (
          <div
            key={dateStr}
            onClick={() => !shareViewState?.active && onDateChange(date)}
            style={{
              backgroundColor: isActive ? THEME.activePill : THEME.inactivePill,
              color: isActive ? THEME.activeText : THEME.inactiveText,
              borderRadius: '20px',
              padding: '6px 14px',
              fontSize: '0.8rem',
              fontFamily: THEME.font,
              letterSpacing: '1px',
              textTransform: 'lowercase',
              whiteSpace: 'nowrap',
              cursor: shareViewState?.active ? 'default' : 'pointer',
              opacity: shareViewState?.active ? 0.5 : 1,
              flexShrink: 0,
              boxShadow: 'var(--shadow-sm)',
              transition: 'background-color 0.2s ease',
            }}
          >
            {getLabel(date)}
          </div>
        );
      })}
    </div>
  );
}
